const getDefaultFeedbackState = () => {
  return { feedbackNote: null, saveNote: false }
}

const state = getDefaultFeedbackState()

const mutations = {
  SET_FEEDBACK_NOTE: (state, note) => {
    state.feedbackNote = note
  },

  SET_SAVE_NOTE: (state, status) => {
    state.saveNote = status
  }
}

export default {
  namespaced: true,
  state,
  mutations
}
